import { render, staticRenderFns } from "./AddModifier.vue?vue&type=template&id=f493e536"
import script from "./AddModifier.vue?vue&type=script&lang=js"
export * from "./AddModifier.vue?vue&type=script&lang=js"
import style0 from "./AddModifier.vue?vue&type=style&index=0&id=f493e536&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports